<template>
  <div class="page">
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'unsubscribe',
  async asyncData(context) {
    const { email } = context.query

    if (!email) {
      return {
        message: 'No email provided in the URL.'
      }
    }

    try {
      const { code } = await context.$api.system.unsubscribeApi(email)
      if (code !== 200) {
        return {
          message: 'Unsubscription Error!'
        }
      }
      return {
        message: 'Unsubscription successful!'
      }
    } catch (error) {
      return {
        message: 'Unsubscription failed. Please try again later.'
      }
    }
  },
  data() {
    return { message: '' }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
